export default "__VITE_ASSET__2f6072e5__"